import Vue from 'vue';

Vue.component('supplier-index', () =>
    import(/* webpackChunkName: 'supplier-index' */ './supplier-index.vue'),
);
